const environment = {
  production: {
    apiPath: process.env.APIPATH || 'https://www.takemetour.com/api',
    mediaPath: 'https://dglw4xbnd0ycq.cloudfront.net',
    webPath: 'https://www.takemetour.com',
    assetPath: 'https://s3-ap-southeast-1.amazonaws.com/takemetour-3-0',
    globaltixApi: 'https://sg-api.globaltix.com/api'
  },
  staging: {
    apiPath: process.env.APIPATH || 'https://staging.takemetour.com/api',
    globaltixApi: 'https://uat-api.globaltix.com/api'
  }
}[process.env.REACT_APP_ENV || 'development'];

module.exports = Object.assign({
  apiPath: process.env.APIPATH || 'https://staging.takemetour.com/api',
  mediaPath: 'https://dja3e86j343dh.cloudfront.net',
  webPath: 'https://staging.takemetour.com',
  assetPath: 'https://s3-ap-southeast-1.amazonaws.com/takemetour-3-0-dev',
  globaltixApi: 'https://uat-api.globaltix.com/api'
}, environment);



// WEBPACK FOOTER //
// ./src/config.js